import styled, { css } from "styled-components";
import { portalColors } from "src/components";

// Styled Components
export const TextArea = styled.textarea`
    font-family: Manrope, Helvetica, sans-serif;
    color: ${portalColors.text};
    font-size: ${p => p.fontSize || "1rem"};
    width: 100%;
    box-sizing: border-box;
    height: 180px;
    border: 1px solid ${portalColors.borderStrong};
    padding: 10px 20px;
    border-radius: 8px;
    text-align: left;
    font-weight: 400;
    caret-color: ${portalColors.text};
    background: ${p => p.disabled ? portalColors.surfaceTertiary : portalColors.surface};
    resize: none;

    ::placeholder {
        color: ${portalColors.textSoft};
        font-weight: 400;
        text-align: left;
        font-size: ${p => p.placeholderSize || "0.875rem"};
    }
    
    &:focus {
        outline: none;
        border: 1px solid ${portalColors.text};
        box-shadow: 0 0 0 4px ${portalColors.blueSoft};
    };
    
    ${ p => p.isHighlighted && css`
        border: 1px solid ${portalColors.danger} !important;
    `};
`;

export const PhoneContainer = styled.div`
    align-items: center;
    display: flex;
    flex-shrink: 0;
    width: 100%;
    justify-content: center;
    min-height: 42rem;
    @media (max-width: 600px) {
        width: 100%;
        min-height: 32rem;
    }
`;

export const FormRightSection = styled.div`
    width: auto;
    min-width: 0;
    display: grid;
    gap: 1rem;
`;

export const FormAssetSection = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 1rem;
    @media (min-width: 1001px) {
        column-gap: 1rem;
    };
    @media (max-width: 1000px) {
        column-gap: 1rem;
    };
`;
